"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.color = void 0;
const foundation_1 = require("../foundation/");
const utils_react_1 = require("@icarros/utils-react");
exports.color = {
    action: {
        primary: {
            ids_color_action_primary_base: foundation_1.foundation_colors.orange_icarros.color_orangeIcarros_50,
            ids_color_action_primary_variant: foundation_1.foundation_colors.orange_icarros.color_orangeIcarros_60,
            ids_color_action_primary_contrast: foundation_1.foundation_colors.black_white.color_white,
        },
        secondary: {
            ids_color_action_secondary_base: foundation_1.foundation_colors.purple_icarros.color_purpleIcarros_50,
            ids_color_action_secondary_base_soft: foundation_1.foundation_colors.purple_icarros.color_purpleIcarros_soft,
            ids_color_action_secondary_variant: foundation_1.foundation_colors.purple_icarros.color_purpleIcarros_70,
            ids_color_action_secondary_contrast: foundation_1.foundation_colors.black_white.color_white,
        },
        neutral: {
            ids_color_action_neutral_base: foundation_1.foundation_colors.sand.color_sand_70,
            ids_color_action_neutral_variant: foundation_1.foundation_colors.sand.color_sand_80,
            ids_color_action_neutral_contrast: foundation_1.foundation_colors.black_white.color_white,
        },
        disabled: {
            ids_color_action_disabled_base: foundation_1.foundation_colors.sand.color_sand_30,
            ids_color_action_disabled_variant: foundation_1.foundation_colors.sand.color_sand_80,
        },
    },
    text: {
        heading: {
            ids_color_text_heading_01: foundation_1.foundation_colors.sand.color_sand_90,
            ids_color_text_heading_02: foundation_1.foundation_colors.sand.color_sand_70,
        },
        body: {
            ids_color_text_body_01: foundation_1.foundation_colors.sand.color_sand_90,
            ids_color_text_body_02: foundation_1.foundation_colors.sand.color_sand_70,
        },
        highlight: {
            ids_color_text_highlight: foundation_1.foundation_colors.orange_icarros.color_orangeIcarros_50,
        },
        link: {
            ids_color_text_link_secondary_base: foundation_1.foundation_colors.purple_icarros.color_purpleIcarros_50,
            ids_color_text_link_secondary_variant: foundation_1.foundation_colors.purple_icarros.color_purpleIcarros_70,
        },
    },
    backgrounds: {
        ids_color_bg_base: foundation_1.foundation_colors.black_white.color_white,
        ids_color_bg_variant_01: foundation_1.foundation_colors.sand.color_sand_10,
        ids_color_bg_variant_02: foundation_1.foundation_colors.sand.color_sand_20,
        ids_color_bg_brand_primary: foundation_1.foundation_colors.orange_icarros.color_orangeIcarros_50,
        ids_color_bg_brand_secondary: foundation_1.foundation_colors.purple_icarros.color_purpleIcarros_50,
        ids_color_bg_brand_gradient: `linear-gradient(
      ${foundation_1.foundation_gradient.direction.gradient_direction_bottomRight},
      ${(0, utils_react_1.hexToRgba)(foundation_1.foundation_colors.orange_icarros.color_orangeIcarros_40)} ${foundation_1.foundation_size.percent.size_percent_100},
      ${(0, utils_react_1.hexToRgba)(foundation_1.foundation_colors.orange_icarros.color_orangeIcarros_20)} ${foundation_1.foundation_size.percent.size_percent_100}
    )`,
    },
    border: {
        ids_color_border_soft: foundation_1.foundation_colors.sand.color_sand_30,
        ids_color_border_medium: foundation_1.foundation_colors.sand.color_sand_50,
        ids_color_border_strong: foundation_1.foundation_colors.sand.color_sand_80,
    },
    contrast: {
        ids_color_contrast_onLight: foundation_1.foundation_colors.black_white.color_black,
        ids_color_contrast_onLight_medium: foundation_1.foundation_colors.black_white.color_black_medium,
        ids_color_contrast_onLight_strong: foundation_1.foundation_colors.black_white.color_black_strong,
        ids_color_contrast_onDark: foundation_1.foundation_colors.black_white.color_white,
        ids_color_contrast_onDark_medium: foundation_1.foundation_colors.black_white.color_white_medium,
        ids_color_contrast_onDark_strong: foundation_1.foundation_colors.black_white.color_white_soft,
        ids_color_contrast_onDark_soft: foundation_1.foundation_colors.black_white.color_white_strong,
        ids_color_contrast_onBrand_primary: foundation_1.foundation_colors.black_white.color_white,
        ids_color_contrast_onBrand_secondary: foundation_1.foundation_colors.black_white.color_white,
    },
    feedbacks: {
        ids_color_feedback_information: foundation_1.foundation_colors.purple_icarros.color_purpleIcarros_50,
        ids_color_feedback_information_contrast: foundation_1.foundation_colors.black_white.color_white,
        ids_color_feedback_success: foundation_1.foundation_colors.green_olive.color_greenOlive_50,
        ids_color_feedback_success_contrast: foundation_1.foundation_colors.black_white.color_white,
        ids_color_feedback_error: foundation_1.foundation_colors.red_ruby.color_redRuby_60,
        ids_color_feedback_error_contrast: foundation_1.foundation_colors.black_white.color_white,
        ids_color_feedback_alert: foundation_1.foundation_colors.red_ruby.color_redRuby_60,
        ids_color_feedback_alert_contrast: foundation_1.foundation_colors.black_white.color_white,
        ids_color_feedback_neutral: foundation_1.foundation_colors.sand.color_sand_80,
        ids_color_feedback_neutral_contrast: foundation_1.foundation_colors.black_white.color_white,
    },
    background_shimmer: {
        ids_color_bg_shimmer_gradient: `linear-gradient(
      ${foundation_1.foundation_gradient.direction.gradient_direction_right},
      ${(0, utils_react_1.hexToRgba)(foundation_1.foundation_colors.sand.color_sand_20)} ${foundation_1.foundation_size.percent.size_percent_0},
      ${(0, utils_react_1.hexToRgba)(foundation_1.foundation_colors.sand.color_sand_50)} ${foundation_1.foundation_size.percent.size_percent_100}
    )`,
        ids_color_bg_shimmer_gradient_onLight: `linear-gradient(
      ${foundation_1.foundation_gradient.direction.gradient_direction_right},
      ${(0, utils_react_1.hexToRgba)(foundation_1.foundation_colors.black_white.color_black, foundation_1.foundation_opacity.opacity.opacity_10)} ${foundation_1.foundation_size.percent.size_percent_0},
      ${(0, utils_react_1.hexToRgba)(foundation_1.foundation_colors.black_white.color_black, foundation_1.foundation_opacity.opacity.opacity_80)} ${foundation_1.foundation_size.percent.size_percent_100}
    )`,
        ids_color_bg_shimmer_gradient_onDark: `linear-gradient(
      ${foundation_1.foundation_gradient.direction.gradient_direction_right},
      ${(0, utils_react_1.hexToRgba)(foundation_1.foundation_colors.black_white.color_white, foundation_1.foundation_opacity.opacity.opacity_10)} ${foundation_1.foundation_size.percent.size_percent_0},
      ${(0, utils_react_1.hexToRgba)(foundation_1.foundation_colors.black_white.color_white, foundation_1.foundation_opacity.opacity.opacity_80)} ${foundation_1.foundation_size.percent.size_percent_100}
    )`,
    },
    illustration: {
        ids_color_illustration_primary_01: foundation_1.foundation_colors.orange_icarros.color_orangeIcarros_20,
        ids_color_illustration_primary_02: foundation_1.foundation_colors.orange_icarros.color_orangeIcarros_50,
        ids_color_illustration_secondary_01: foundation_1.foundation_colors.purple_icarros.color_purpleIcarros_50,
        ids_color_illustration_secondary_02: foundation_1.foundation_colors.purple_icarros.color_purpleIcarros_70,
        ids_color_illustration_tertiary_01: foundation_1.foundation_colors.turquoise_cold.color_turquoiseCold_40,
        ids_color_illustration_neutral: foundation_1.foundation_colors.black_white.color_white,
    }
};
//# sourceMappingURL=color.js.map